import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "submitSection", "resultSection", "jikobunsekiResult", "kenkyuResult", "junbiResult", "taisakuResult", "resultSum"]

  connect() {
    this.setupDetailHandlers()
    this.setupSubmitHandler()
  }

  setupDetailHandlers() {
    // MORE項目（詳細チェックボックス）のイベントハンドラー
    const detailCheckboxes = this.element.querySelectorAll('.detail')
    detailCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (event) => {
        this.handleDetailChange(event.target)
      })
    })
  }

  handleDetailChange(checkbox) {
    const parentId = checkbox.dataset.parent
    const parentCheckbox = document.getElementById(parentId)
    
    if (!parentCheckbox) return

    const detailsCount = parseInt(parentCheckbox.dataset.detailCount) || 0
    const checkedDetails = document.querySelectorAll(`input[data-parent="${parentId}"]:checked`).length

    if (detailsCount === checkedDetails && detailsCount > 0) {
      parentCheckbox.checked = true
      parentCheckbox.style.visibility = "visible"
    } else {
      parentCheckbox.style.visibility = "hidden"
      parentCheckbox.checked = false
    }
  }

  setupSubmitHandler() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.addEventListener('click', (event) => {
        event.preventDefault()
        this.handleSubmit()
      })
    }
  }

  handleSubmit() {
    // 各カテゴリのチェック済み項目をカウント
    const jikobunsekiResult = document.querySelectorAll('input.jikobunseki:checked').length
    const kenkyuResult = document.querySelectorAll('input.kenkyu:checked').length
    const junbiResult = document.querySelectorAll('input.junbi:checked').length
    const taisakuResult = document.querySelectorAll('input.taisaku:checked').length

    // 結果を表示
    if (this.hasJikobunsekiResultTarget) {
      this.jikobunsekiResultTarget.textContent = `${jikobunsekiResult}/5`
    }
    if (this.hasKenkyuResultTarget) {
      this.kenkyuResultTarget.textContent = `${kenkyuResult}/5`
    }
    if (this.hasJunbiResultTarget) {
      this.junbiResultTarget.textContent = `${junbiResult}/5`
    }
    if (this.hasTaisakuResultTarget) {
      this.taisakuResultTarget.textContent = `${taisakuResult}/5`
    }

    const sum = jikobunsekiResult + kenkyuResult + junbiResult + taisakuResult
    if (this.hasResultSumTarget) {
      this.resultSumTarget.textContent = `${sum}/20`
    }

    // フォームを非表示にして結果を表示
    if (this.hasSubmitSectionTarget) {
      this.submitSectionTarget.classList.add("d-none")
    }
    if (this.hasResultSectionTarget) {
      this.resultSectionTarget.classList.remove("d-none")
      
      // 結果セクションまでスクロール
      this.resultSectionTarget.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      })
    }
  }
}
